import { fromJS } from 'immutable';
import { isString } from '../../../../../form/formUtilities';

export const runupSearchModel = fromJS({
  name: 'runupSearchForm',
  initialValues: {
    id: '',
    minId: '',
    maxId: '',
    sourceMinYear: '',
    sourceMaxYear: '',
    sourceRegionCode: '',
    sourceCountry: '',
    sourceArea: '',
    sourceMinEventValidity: '',
    sourceMaxEventValidity: '',
    sourceMinCauseCode: '',
    sourceMaxCauseCode: '',
    sourceMinEqMagnitude: '',
    sourceMaxEqMagnitude: '',
    sourceOceanicTsunami: '',
    regionCode: '',
    country: '',
    area: '',
    minDistFromSource: '',
    maxDistFromSource: '',
    minLatitude: '',
    maxLatitude: '',
    minLongitude: '',
    maxLongitude: '',
    typeMeasurementId: '',
    minRunupHt: '',
    maxRunupHt: '',
    minDeaths: '',
    maxDeaths: '',
    minDeathsAmountOrder: '',
    maxDeathsAmountOrder: '',
    minDamageMillionsDollars: '',
    maxDamageMillionsDollars: '',
    minDamageAmountOrder: '',
    maxDamageAmountOrder: '',
    minInjuries: '',
    maxInjuries: '',
    minInjuriesAmountOrder: '',
    maxInjuriesAmountOrder: '',
    minHousesDestroyed: '',
    maxHousesDestroyed: '',
    minHousesDestroyedAmountOrder: '',
    maxHousesDestroyedAmountOrder: '',
    minHousesDamaged: '',
    maxHousesDamaged: '',
    minHousesDamagedAmountOrder: '',
    maxHousesDamagedAmountOrder: '',
    minTravHours: '',
    maxTravHours: '',
    doubtful: '',
    minRunupHoriz: '',
    maxRunupHoriz: '',
    minTroughHt: '',
    maxTroughHt: '',

    radios: {
      locationSearchType: 'locInclude',
      loc: '',
      commentsSearchType: 'commentsInclude',
      comments: '',
    },
  },
});


export const toSearchParameters = (model) => {
  const search = model.toJS();
  const {
    radios: {
      locationSearchType,
      loc,
      commentsSearchType,
      comments,
    },
  } = search;

  if (locationSearchType) {
    search[locationSearchType] = loc;
  }

  if (commentsSearchType) {
    search[commentsSearchType] = comments;
  }

  delete search.radios;


  Object.keys(search).forEach((key) => {
    let value = search[key];
    if (isString(value)) {
      value = value.trim();
      if (value) {
        search[key] = value;
      } else {
        delete search[key];
      }
    }
  });

  return search;
};
